<template>
    <div>
        <chat-message type="system" class="mb-1">

            <div v-if="response && !clickedStop">

                <!-- Typing effect with plain text -->
                <text-typed
                        v-if="isTyping"
                        :text="responseText"
                        @start="onServerTypingStart"
                        @done="onServerTypingDone"
                        :stopped="clickedStop"
                ></text-typed>

                <!-- once typing finishes, swipe out the "typer" component, with another component -->
                <chat-question-response v-else :response="response"></chat-question-response>
            </div>

            <div v-else-if="clickedStop">
                Response generation was stopped, try entering a new question.
            </div>

            <div v-else-if="error" class="red--text">
                {{ error }}
            </div>

            <text-typed
                v-else-if="isWaitingServerResponse"
                :text="randomThinkingText"
                :stopped="clickedStop"
                :speed="5"
            ></text-typed>
        </chat-message>

        <div class="server-message-stop" v-if="isWaitingServerResponse || isTyping">

            <v-btn
                text
                small
                @click="stopGeneratingClicked"
            >
                <v-icon left>mdi-close</v-icon>
                Stop generating response
            </v-btn>
        </div>

        <div class="server-message-rating text-sm d-flex align-center" v-else-if="responseText && !clickedStop">
            <strong>Rate this answer</strong>

            <v-btn icon @click="rateAnswerClicked(true)">
                <v-icon color="primary">{{ userFeedback === 1 ? 'mdi-thumb-up' : 'mdi-thumb-up-outline' }}</v-icon>
            </v-btn>

            <v-btn icon @click="rateAnswerClicked(false)">
                <v-icon color="primary">{{ userFeedback === -1 ? 'mdi-thumb-down' : 'mdi-thumb-down-outline' }}</v-icon>
            </v-btn>
        </div>

    </div>
</template>

<script>
import AssetImage from "../../AssetImage.vue";
import { ApiService } from "../../../api/ApiService";
import ChatMessage from "./ChatMessage.vue";
import { ArrayUtils } from "../../../util/ArrayUtils";
import SectionContent from '../../dashboard/quick_access/section_content.vue';
import SectionContentProxy from "../../SectionContentProxy.vue";
import TextTyped from "../../TextTyped.vue";
import MarkdownText from "../../MarkdownText.vue";
import ChatQuestionResponse from "./ChatQuestionResponse.vue";

export default {
    components: {
        ChatQuestionResponse,
        MarkdownText,
        SectionContentProxy,
        ChatMessage,
        AssetImage,
        TextTyped,
        SectionContent
    },
    emits: ['stopped'],
    props: {
        prompt: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            thinkingText: [
                'Researching your question, this may take a moment.',
                'Please allow a moment while finding the best answer to your inquiry.',
                'Being accurate is more important than being first.  I am working to compose the best answer based on your inputs.',
                'Please be patient while I analyze all the requirements for your situation.',
                'Considering all the possibilities for your situation while crafting your response.',
            ],
            clickedStop: false,
            isTyping: false,
            userFeedback: null,
        }
    },
    computed: {
        randomThinkingText() {
            return ArrayUtils.rand(this.thinkingText);
        },
        question() {
            return this.prompt?.question || "";
        },
        response() {
            return this.prompt?.response;
        },
        isWaitingServerResponse() {
            return !this.response;
        },
        responseText() {
            return this.response?.text || "";
        },
        questionId() {
            return this.response?.messageId;
        },
        error() {
            return this.prompt?.error || "";
        }
    },
    methods: {
        stopGeneratingClicked() {
            this.clickedStop = true;
            this.notifyParentStopped();
        },
        rateAnswerClicked(rating) {
            const feedback = rating ? 1 : -1;
            this.userFeedback = feedback;
            ApiService.sendFeedbackGpt(this.response.messageId, feedback).catch(() => {
                // alert('Failed to send feedback');
            });
        },
        onServerTypingStart() {
            this.isTyping = true;
        },
        onServerTypingDone() {
            this.isTyping = false;
        },
        notifyParentStopped() {
            this.$emit('stopped');
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    }
}
</script>

<style lang="scss">
span.ai-reference-section ins {
    text-decoration: none !important;
}
</style>
